<template>
</template>
<script>
	export default {
		data() {
			let vm = this;
			return {
				element: null,
				resources: {

					textCounter: {
						name: 'textCounter',
						init: 0,
						finish: 1000,
						timer: 2000,
						min: 0,
						max: 100,
						labelDesc: 'button-textCounter',
						canRemove: false,
						callback: function () {
							vm.resources.textCounter.init = parseInt(this.valueInit);
							vm.element.internal_config.init = parseInt(this.valueInit);

							vm.resources.textCounter.finish = parseInt(this.valueFinish);
							vm.element.internal_config.finish = parseInt(this.valueFinish);

							vm.resources.textCounter.timer = parseInt(this.valueTimer);
							vm.element.internal_config.timer = parseInt(this.valueTimer) * 1000;

						},
					},

					zIndex: {
						name: 'zIndex',
						defaultValue: '',
						labelDesc: 'zIndex',
						callback: function () {
							vm.resources.zIndex.defaultValue = this.value;
							vm.element.internal_config.zIndex = this.value;

						},
					},
					border: {
						name: 'border',
						defaultValue: '1px solid black',
						min: '0',
						max: '50',
						labelDesc: 'border',
						callback: function () {
							let value = this.value + 'px ' + this.value2 + ' ' + this.value3;

							vm.resources.border.defaultValue = value;
							vm.element.internal_config.border = value;
						},
					},
					borderRadius: {
						name: 'borderRadius',
						defaultValue: '0 0 0 0',
						min: '0',
						max: '360',
						labelDesc: 'borderRadius',
						callback: function () {

							let value = this.v1 + 'px ' + this.v2 + 'px ' + this.v3 + 'px ' + this.v4 + 'px';

							vm.resources.borderRadius.defaultValue = value;
							vm.element.internal_config.borderRadius = value;
						},
					},
					backgroundColor: {
						name: 'backgroundColor',
						defaultValue: '#ffffff',
						labelDesc: 'resource-bg-color',
						callback: function () {
							vm.resources.backgroundColor.defaultValue = this.colorValue;
							vm.element.internal_config.backgroundColor = this.colorValue;
						},
					},
					backgroundColorBar: {
						name: 'backgroundColorBar',
						defaultValue: '#ffffff',
						labelDesc: 'resource-bg-color-bar',
						callback: function () {
							vm.resources.backgroundColorBar.defaultValue = this.colorValue;
							vm.element.internal_config.backgroundColorBar = this.colorValue;
						},
					},
					boxShadow: {
						name: 'boxShadow',
						defaultValue: '0 0 0 0 black initial',
						min: '0',
						max: '50',
						labelDesc: 'boxShadow',
						callback: function () {

							let value = this.h + 'px ' + this.v + 'px ' + this.b + 'px ' + this.s + 'px ' + this.colorValue + ' ' + (this.i === true ? 'inset' : '');

							vm.resources.boxShadow.defaultValue = value;
							vm.element.internal_config.boxShadow = value;
						},
					},
					padding: {
						name: 'padding',
						defaultLeft: '15',
						defaultTop: '15',
						defaultRight: '15',
						defaultBottom: '15',
						min: '0',
						max: '100',
						labelDesc: 'padding',
						callback: function () {
							vm.resources.padding.defaultLeft = this.l;
							vm.element.internal_config.paddingLeft = this.l + 'px';

							vm.resources.padding.defaultTop = this.t;
							vm.element.internal_config.paddingTop = this.t + 'px';

							vm.resources.padding.defaultRight = this.r;
							vm.element.internal_config.paddingRight = this.r + 'px';

							vm.resources.padding.defaultBottom = this.b;
							vm.element.internal_config.paddingBottom = this.b + 'px';
						},
					},
				}
			}
		},
		methods: {
			setValuesData(data) {
				this.element = data;

				// this.resources.width.defaultValue = parseInt(data.internal_config.width);
				// this.resources.height.defaultValue = parseInt(data.internal_config.height);

				this.resources.border.defaultValue = data.internal_config.border;
				this.resources.borderRadius.defaultValue = data.internal_config.borderRadius;
				this.resources.boxShadow.defaultValue = data.internal_config.boxShadow;

				this.resources.backgroundColor.defaultValue = data.internal_config.backgroundColor;
				this.resources.backgroundColorBar.defaultValue = data.internal_config.backgroundColorBar;


				this.resources.textCounter.init = data.internal_config.init;
				this.resources.textCounter.finish = data.internal_config.finish;
				this.resources.textCounter.timer = data.internal_config.timer / 1000;

				this.resources.padding.defaultLeft = parseInt(data.internal_config.paddingLeft);
				this.resources.padding.defaultTop = parseInt(data.internal_config.paddingTop);
				this.resources.padding.defaultRight = parseInt(data.internal_config.paddingRight);
				this.resources.padding.defaultBottom = parseInt(data.internal_config.paddingBottom);
			},
			getValuesData() {
				return this.resources;
			}
		},
	}
</script>
